import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalText from '../common/LocalText';

const ComingSoonPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                textAlign: 'center',
                color: '#0a326d',
                px: 3,
            }}
        >
            <Typography
                variant="h2"
                fontWeight={700}
                sx={{ fontSize: { xs: '2rem', sm: '2.75rem', md: '3.5rem' }, mb: 1.5, letterSpacing: '-0.5px' }}
            >
                <LocalText>Coming Soon</LocalText>
            </Typography>
            <Typography
                variant="body1"
                sx={{ fontSize: { xs: '0.95rem', sm: '1.1rem' }, color: '#4a6fa5', fontWeight: 500 }}
            >
                <LocalText>Currently Under Construction</LocalText>
            </Typography>
        </Box>
    );
};

export default ComingSoonPage;
